import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDownloadLink } from '../services/apiService';

export const useFileBrowser = (currentPath, breadcrumbs) => {
    const navigate = useNavigate();

    const handleFolderClick = useCallback((folder) => {
        if (folder.isFolder) {
            const newPath = currentPath ? `${currentPath}/${folder.name}` : folder.name;
            navigate(`/${newPath}`);
        }
    }, [currentPath, navigate]);

    const handleBreadcrumbClick = useCallback((index) => {
        if (!breadcrumbs || index >= breadcrumbs.length - 1) return;
        const breadcrumb = breadcrumbs[index];
        navigate(breadcrumb.path ? `/${breadcrumb.path}` : '/');
    }, [breadcrumbs, navigate]);

    const handleDownload = useCallback((file, e) => {
        e.stopPropagation();
        if (file.isFolder) return;
        window.location.href = getDownloadLink(file.id);
    }, []);

    const goBack = useCallback(() => {
        if (breadcrumbs && breadcrumbs.length > 1) {
            const prevCrumb = breadcrumbs[breadcrumbs.length - 2];
            navigate(prevCrumb.path ? `/${prevCrumb.path}` : '/');
        }
    }, [breadcrumbs, navigate]);

    return {
        handleFolderClick,
        handleBreadcrumbClick,
        handleDownload,
        goBack
    };
};
